const arbitrageRoutes = [
  {
    path: "/acquisition/campain-main",
    name: "campain-main",
    component: () => import("@/views/acquisition/campaign_manager/Index.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "arbitrage-campain-main",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/acquisition/campain-tracker",
    name: "campain-tracker",
    component: () => import("@/views/acquisition/campaign_manager/Tracker.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/campaign-redirect",
    name: "campaign-redirect",
    component: () => import("@/views/acquisition/CampaignRedirect.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
      rmrAnalytics: {
        track: true,
        eventType: "campaign-redirect-create-link",
        eventCategory: "page-view",
      },
    },
  },
  {
    path: "/acquisition/crawlers",
    name: "acquisition-crawlers",
    component: () => import("@/views/acquisition/Crawlers.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/daily-report",
    name: "daily-report",
    component: () => import("@/views/acquisition/AcquiDailyReport/Index.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/daily-report-config",
    name: "daily-report-config",
    component: () =>
      import("@/views/acquisition/AcquiDailyReport/DailyReportConfig.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/daily-report-utms",
    name: "daily-report-utms",
    component: () =>
      import("@/views/acquisition/AcquiDailyReport/DailyReportUtm.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/utm-content",
    name: "utm-content",
    component: () => import("@/views/acquisition/UtmContent/Index.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
  {
    path: "/acquisition/utm-content-whitelist",
    name: "utm-content-whitelist",
    component: () =>
      import("@/views/acquisition/UtmContent/UtmContentWhitelist.vue"),
    meta: {
      layout: "content",
      resource: "arbitrage_campaign",
      action: "manage",
    },
  },
];

export default arbitrageRoutes;
